/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Injector } from '@angular/core';
import { VirtualServiceCollection } from 'collections/virtual-service.collection.factory';
import { VIRTUAL_SERVICE_COLLECTION_TOKEN } from 'ajs/modules/vs/vs.constants';

const $injector = '$injector';

export const virtualServiceCollectionProvider = {
    deps: [$injector],
    provide: VirtualServiceCollection,
    useFactory(injector: Injector): typeof VirtualServiceCollection {
        return injector.get(VIRTUAL_SERVICE_COLLECTION_TOKEN);
    },
};

export const metricDataCollectionProvider = {
    deps: [$injector],
    provide: 'MetricDataCollection',
    useFactory(injector: Injector): any {
        return injector.get('MetricDataCollection');
    },
};

export const dnsQueryCollectionProvider = {
    deps: [$injector],
    provide: 'DNSQueryCollection',
    useFactory(injector: Injector): any {
        return injector.get('DNSQueryCollection');
    },
};
